import { Receipt } from "lucide-react";
import { EntityLink, EntityLinkPlain } from "./EntityLink";

/**
 * InvoiceLink — canonical invoice-number rendering, e.g. "INV-0451-2024-02-001",
 * deep-linking to the invoices page focused on that invoice (`?invoice_id=`).
 * Falls back to plain text when `invoiceId` is missing.
 */
export interface InvoiceLinkProps {
  invoiceId?: string | null;
  invoiceNumber?: string | null;
  className?: string;
  "data-testid"?: string;
}

export function InvoiceLink({
  invoiceId,
  invoiceNumber,
  className,
  "data-testid": dataTestId,
}: InvoiceLinkProps) {
  const label = invoiceNumber && invoiceNumber.length > 0 ? invoiceNumber : "—";
  if (!invoiceId) {
    return (
      <EntityLinkPlain
        icon={Receipt}
        title={label}
        className={className}
        data-testid={dataTestId}
      >
        {label}
      </EntityLinkPlain>
    );
  }
  return (
    <EntityLink
      to={`/billing/invoices?invoice_id=${encodeURIComponent(invoiceId)}`}
      icon={Receipt}
      title={label}
      className={className}
      data-testid={dataTestId}
    >
      {label}
    </EntityLink>
  );
}
